var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAcurast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9998 6H7.99966L3 16.8328H10.0002L14.9998 6Z",
    fill: "#B4E600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9993 12.5H18.9992L21.9999 19.0001H16L12.9993 12.5Z",
    fill: "#B4E600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcurast);
export default __webpack_public_path__ + "static/media/acurast.ea296c9e16ece55a07c9f8670a882abc.svg";
export { ForwardRef as ReactComponent };